module.exports = "/static/media/arrows.72bc11c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrows.svg
// module id = 192
// module chunks = 0